<template>
  <div class="columns account-info-wrapper">
    <div class="column img-column">
      <img width="auto" src="@/assets/carrier-perks-imgs/otr-leasing.png"/>
    </div>
    <div class="column is-two-thirds content">
      <p>
        Truckl partners with OTR Leasing to provide our carriers with access to great leasing offers and world-class services. OTR Offers Truckl carriers ...
      </p>
      <div class="columns is-multiline">
        <div class="column">
          <a href="https://otrleasing.com/the-program/" target="_blank">How It Works</a>
        </div>
        <div class="column">
          <a href="https://otrleasing.com/credit/?utm_source=google&utm_medium=cpc&utm_campaign=MT%20-%20OTR%20-%20Brand&utm_content=otr%20leasing&utm_term=otr%20leasing&utm_device=" target="_blank">Apply Now</a>
        </div>
        <div class="column">
          <a href="https://otrleasing.com/inventory/" target="_blank">View Inventory</a>
        </div>
        <!--
        <div class="column is-full has-text-centered is-vcentered">
          <img src="https://via.placeholder.com/400x300"/>
        </div>
        -->
      </div>
    </div>


  </div>
</template>

<script>
import AccountInfo from '../AccountInfo'
import CarrierInfo from '../CarrierInfo'

export default {
  name: 'LeasingOffers',

  components: {
    AccountInfo,
    CarrierInfo
  }
}
</script>

<style scoped lang="scss">
@import 'styles';

img {
  height: auto;
  width: auto;
}

.img-column {
  background: rgb(68, 84, 105);
  margin-left: 3px;
}

.columns {
  height: auto;
}
</style>
